/**
 * Checks if a value is a valid number
 * @param value - The value to check
 * @returns True if the value is a valid number
 */
export const isValidNumber = (value: string | number | null | undefined): boolean => {
    if (value === "" || value === null || value === undefined) {
        return false;
    }
    const num = Number(value);
    return !Number.isNaN(num) && Number.isFinite(num);
};
